import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_RESULTS_PER_PAGE } from "../../constants/pagination";
const initialState = {
  activePage: 1,
  pageSize: DEFAULT_RESULTS_PER_PAGE,
  resultsCount: null,
  queryString: "",
  lastQueryString: "",
  filtersOpened: false,
  filters: [],
  showWidenModal: true
};
export const widenSearchSlice = createSlice({
  name: "widenSearch",
  initialState,
  reducers: {
    resetSearch: state => {
      state.activePage = initialState.activePage;
      state.pageSize = initialState.pageSize;
      state.resultsCount = initialState.resultsCount;
      state.queryString = initialState.queryString;
      state.lastQueryString = initialState.lastQueryString;
      state.fileType = initialState.fileType;
      state.filtersOpened = initialState.filtersOpened;
      state.filters = initialState.filters;
      state.showWidenModal = initialState.showWidenModal;
    },
    updateActivePage: (state, action) => {
      const {
        activePage
      } = state;
      const input = action.payload;
      const maxPage = Math.ceil(state.resultsCount / state.pageSize);
      const newActivePage = activePage + input > 0 && activePage + input <= maxPage ? activePage + input : activePage;
      state.activePage = newActivePage;
    },
    resetActivePage: state => {
      state.activePage = 1;
    },
    updatePageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    updateResultsCount: (state, action) => {
      state.resultsCount = action.payload;
    },
    updateQueryString: (state, action) => {
      state.queryString = action.payload;
    },
    updateLastQueryString: (state, action) => {
      state.lastQueryString = action.payload;
    },
    toggleFiltersOpened: state => {
      state.filtersOpened = !state.filtersOpened;
    },
    addFilter: (state, action) => {
      const {
        filterType: newFilterType
      } = action.payload;
      const existingFilter = state.filters.find(({
        filterType
      }) => filterType === newFilterType);
      if (existingFilter) {
        state.filters = state.filters.map(filter => filter.filterType === newFilterType ? action.payload : filter);
      } else {
        state.filters = [...state.filters, action.payload];
      }
    },
    removeFilter: (state, action) => {
      const {
        filterType: filterToRemoveType
      } = action.payload;
      state.filters = state.filters.filter(({
        filterType
      }) => filterType !== filterToRemoveType);
    },
    updateShowWidenModal: (state, action) => {
      state.showWidenModal = action.payload;
    }
  }
});
export const {
  resetSearch,
  updateActivePage,
  updatePageSize,
  resetActivePage,
  updateResultsCount,
  updateQueryString,
  updateLastQueryString,
  toggleFiltersOpened,
  addFilter,
  removeFilter,
  updateShowWidenModal
} = widenSearchSlice.actions;
export default widenSearchSlice.reducer;